import BaseSelectEditorComponent from '../common/BaseSelectEditorComponent';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import I18n from 'I18n';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { useCallback, useMemo } from 'react';
import { getCustomFilters, getDataType, getReportConfig } from 'reporting-data/report/configReportGetters';
import { GOAL_TARGET_PROPERTIES } from 'reporting-data/constants/goalProperties';
import { fromJS } from 'immutable';
import { getRequiredGoalReportEditors } from '../getDynamicReportEditors';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getProperty } from 'reporting-data/properties/getProperty';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const useGetProperty = report => {
  const dataType = getDataType(report);
  const fetcher = useCallback(() => {
    return getProperty(dataType, GOAL_TARGET_PROPERTIES.HS_KPI_UNIT_TYPE);
  }, [dataType]);
  return useAsyncFetcher({
    fetcher
  });
};
function GoalsKPIUnitTypeEditor({
  onChange,
  report
}) {
  const asyncProperty = useGetProperty(report);
  const handleDatePropertyChange = useCallback(({
    target: {
      value: newProperty
    }
  }) => {
    const updatedReport = report.updateIn(['config', 'filters', 'custom'], currentCustomFilters => {
      const unitTypeFilters = currentCustomFilters.filter(filter => filter.get('property') !== GOAL_TARGET_PROPERTIES.HS_KPI_UNIT_TYPE).concat(fromJS([{
        operator: 'EQ',
        property: GOAL_TARGET_PROPERTIES.HS_KPI_UNIT_TYPE,
        value: newProperty
      }]));
      return unitTypeFilters;
    });
    return onChange(updatedReport);
  }, [report, onChange]);
  const renderButtonContent = () => {
    if (!isSucceeded(asyncProperty)) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    return /*#__PURE__*/_jsx(TruncateString, {
      tooltip: false,
      maxWidth: 100,
      children: I18n.text('settingLabels.quickFilter.label', {
        propertyLabel: asyncProperty.data.get('label')
      })
    });
  };
  const options = useMemo(() => {
    if (!isSucceeded(asyncProperty)) {
      return [];
    }
    const propertyOptions = asyncProperty.data.get('options').toJS();
    return propertyOptions.map(option => ({
      text: option.label,
      value: option.value
    }));
  }, [asyncProperty]);
  const value = useMemo(() => {
    const customFilter = getCustomFilters(getReportConfig(report)).find(filter => filter.get('property') === GOAL_TARGET_PROPERTIES.HS_KPI_UNIT_TYPE);
    return customFilter ? customFilter.get('value') : 'currency';
  }, [report]);
  if (isLoading(asyncProperty)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "srv-goals-kpi-unit-type-editor-loading",
      size: "extra-small"
    });
  }
  return /*#__PURE__*/_jsx(BaseSelectEditorComponent, {
    tooltipHeader: renderButtonContent(),
    dataTestId: "srv-goals-kpi-unit-type-editor",
    onChange: handleDatePropertyChange,
    options: options,
    value: value
  });
}
GoalsKPIUnitTypeEditor.displayName = 'GoalsKPIUnitTypeEditor';
GoalsKPIUnitTypeEditor.isUsableForReport = report => {
  return isConfigReport(report) ? getRequiredGoalReportEditors(report).length > 0 : false;
};
GoalsKPIUnitTypeEditor.isFilterEditor = true;
export default GoalsKPIUnitTypeEditor;